import React from 'react';
import { getPhotoName } from '../../challengeConstants';

export default function ImageCard2026({
  type,
  photo,
  photos,
  handleImageUpload,
  loadGreenOrGreyIdleImages,
  isValidDurationForUpload,
  uploaded,
}) {
  const POSITION_LABEL_MAPPING = {
    center: 'ด้านหน้าตรง',
    left: 'ด้านข้างซ้าย',
    right: 'ด้านข้างขวา',
  };

  const UPLOAD_ICON_MAPPING = {
    active: 'Icon-upload',
    uploaded: 'gm-notification/greenCheckmark',
    disabled: 'Icon-upload',
  };
  const IconName = (isValidDurationForUpload && uploaded && UPLOAD_ICON_MAPPING.uploaded) ||
    (isValidDurationForUpload && !uploaded && UPLOAD_ICON_MAPPING.active) || 
    (!isValidDurationForUpload && UPLOAD_ICON_MAPPING.disabled)

  const isDisabled = isValidDurationForUpload && !uploaded;

  const onUploadTrigger = () => {
    if (isValidDurationForUpload && !uploaded) {
      handleImageUpload && handleImageUpload(getPhotoName(type, photo));
    }
  };

  return (
    <div
      className={`image-list-image-single-wrapper ${
        isValidDurationForUpload
          ? ''
          : 'image-list-image-single-wrapper--disabled'
      }`}
      onClick={onUploadTrigger}
    >
      <span
        key={getPhotoName(type, photo)}
        className="image-list-image-single image-list-image-uploaded pointer"
      >
        <img
          src={
            photos[getPhotoName(type, photo)]
              ? photos[getPhotoName(type, photo)]
              : `/images/challenge/myupload/photo_c12_${loadGreenOrGreyIdleImages(photo)}.svg`
          }
          className="image-list-img-uploaded"
          alt={getPhotoName(type, photo)}
        />
      </span>
      <div className={`image-list-image-single__label${isValidDurationForUpload ? '' : '--disabled'}`}>
        {POSITION_LABEL_MAPPING[photo]}
      </div>
      <div className={`image-list-image-single_icon-wrapper${isDisabled ? '--disabled' : ''}`}>
        <img src={`/images/${IconName}.png`} className="image-list-image-single_icon" />
        <div className="image-list-image-single_upload-status">{uploaded ? 'อัพโหลดแล้ว' : 'อัพโหลดรูป'}</div>
      </div>
    </div>
  );
}
